import type { SubstancesFlowRoute, SubstancesState } from "./SubstancesContext";

export function buildSubstancesNavigationStack(
  state: SubstancesState,
): SubstancesFlowRoute[] {
  const stack: SubstancesFlowRoute[] = ["SubstancesIntro"];

  if (state.hasSubstances === true) {
    stack.push("SubstancesSelect");

    state.selectedSubstances.forEach((substance) => {
      if (substance) {
        stack.push({ type: "SubstanceDetails", substance });
      }
    });
  }

  stack.push("SubstancesComplete");

  return stack;
}
